import { ImageBackground, ImageBackgroundProps } from 'expo-image';

import { YStack, createMqStyles, useMqSelect } from '@fhs/ui';

import { CtaButton } from '../shared/cta-button';

export type MontrealSmokedMeatCardProps = Omit<ImageBackgroundProps, 'children' | 'source'> & {
  pickUpHref: string;
};
export function MontrealSmokedMeatCard(props: MontrealSmokedMeatCardProps) {
  const mqStyles = useMqStyles();

  return (
    <ImageBackground
      source={useMqSelect(
        {
          $gteDesktopLg: require('./montreal-smoked-meat-background.webp'),
        },
        require('./montreal-smoked-meat-background-tablet.webp')
      )}
      placeholder={useMqSelect(
        { $gteDesktopLg: { thumbhash: 'HkkGE4SbGmeAiFWJYJQEg1k' } },
        { thumbhash: 'HkkGE4SbN2mgaFZ7cKMDdTo' }
      )}
      {...props}
      style={[mqStyles.banner, props.style]}
    >
      <YStack style={mqStyles.contentContainer}>
        <CtaButton href={props.pickUpHref} style={mqStyles.cta} />
      </YStack>
    </ImageBackground>
  );
}

const useMqStyles = createMqStyles({
  banner: {
    $base: {
      aspectRatio: 1024 / 504,
    },
    $gteDesktopLg: {
      aspectRatio: 1920 / 757,
    },
  },
  contentContainer: {
    $base: {
      position: 'absolute',
    },
    $ltDesktopLg: {
      left: '15%',
      top: '65%',
      width: '20%',
    },
    $gteDesktopLg: {
      left: '10%',
      top: '70%',
      width: '20%',
    },
  },

  caption: {
    $base: {
      aspectRatio: 581 / 444,
    },
  },

  cta: {
    $base: {
      marginHorizontal: 'auto',
    },
  },
});
